// The sign-up's addresses (Vova 29.10.2026). Three start pages: the regular one and two promos, each with the same
// steps under it; /complete/ is one for all.
export const SIGNUP_BASES = ['/', '/blackfriday/', '/lovely-user/winback/'];

export const STEP_PATHS = {
    AuthStep: '',
    CompanyStep: 'setup/',
    TrialStep: 'trial/',
} as const;

export type StepType = keyof typeof STEP_PATHS;

// The start page an address belongs to: the promo it starts with, or the regular one.
export function signupBase(pathname: string): string {
    return SIGNUP_BASES.slice(1).find((base) => pathname.startsWith(base)) ?? '/';
}
